"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const common_components_1 = require("@yandex-int/pythia-libs/lib/common-components");
const markdown_renderer_1 = __importDefault(require("@yandex-int/pythia-libs/lib/markdown-renderer"));
const branding_1 = require("src/context/branding");
const modal_1 = require("src/context/modal");
const question_choice_styles_1 = require("./question-choice.styles");
const i18n = (0, i18n_1.default)(['labels']);
const b = b_1.default.with('choice');
const mdRender = (0, markdown_renderer_1.default)(common_components_1.MARKDOWN_OPTIONS.filter(option => option !== 'image'));
// eslint-disable-next-line complexity
function Option(props) {
    var _a, _b, _c;
    const { id = '', value = -10, label = '', multipleChoice = false, checked = false, handleClickOption, visible = undefined, disabled = false } = props;
    const branding = (0, branding_1.useBrandingContext)();
    const modalContext = (0, modal_1.useModalContext)();
    const optionBranding = ((_a = branding === null || branding === void 0 ? void 0 : branding.choice) === null || _a === void 0 ? void 0 : _a.option) || {};
    const controlType = multipleChoice ? 'checkbox' : 'radio';
    const viewMulti = multipleChoice || Boolean((_c = (_b = optionBranding.control) === null || _b === void 0 ? void 0 : _b.singleChoice) === null || _c === void 0 ? void 0 : _c.enableCheckmark);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: (0, question_choice_styles_1.getOptionStyles)(), className: b('option', {
            checked,
            hidden: visible === false,
            preset: modalContext === null || modalContext === void 0 ? void 0 : modalContext.surveyPreset
        }) }, { children: [visible === false && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('bubble') }, { children: i18n(['optionHidden']) })), (0, jsx_runtime_1.jsx)("input", { checked: checked, type: controlType, id: id, value: value, onChange: handleClickOption, disabled: disabled }), (0, jsx_runtime_1.jsxs)("label", Object.assign({ className: b('option-label', { disabled }), htmlFor: id, "data-test": id }, { children: [(0, jsx_runtime_1.jsx)("div", { className: b('option-control', {
                            checked,
                            multiple: viewMulti ? 'yes' : 'no'
                        }) }), label ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('option-text') }, { children: (0, jsx_runtime_1.jsx)("span", { 
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML: {
                                __html: mdRender(label)
                            } }) }))) : null] }))] }), id));
}
exports.default = Option;
